<template>
  <div class="v-details-inner-form">
    <div class="form__heading">
      <h2 v-if="familyTypeState == 'living_together'" class="form__title">{{partner}}</h2>
      <h2 v-else class="form__title">{{subscriptions}} {{i+1}}</h2>
    </div>
    <ul class="form__list">
      <li class="form__item form__item--no-label">
        <v-radios-public
          :name="`person[`+[i]+`][title_id]`"
          :options="usersTitleOptions"
          v-validate="`required|make_choice`"
        ></v-radios-public>
      </li>
      <li class="form__item">
          <v-radios-public
            :label="locales && locales.users && locales.users.language"
            :value="defaultLanguage"
            :name="`person[`+[i]+`][language]`"
            show-zero-option="0"
            :options="languages"
            v-validate="`required`"
          ></v-radios-public>
        </li>
      <li class="form__item">
        <v-textfield-public
          :label="usersFirstName"
          :name="`person[`+[i]+`][first_name]`"
          v-validate="`required|alpha_spaces_dash`"
        ></v-textfield-public>
      </li>
      <li class="form__item">
        <v-textfield-public :label="usersMiddleName" :name="`person[`+[i]+`][middle_name]`"></v-textfield-public>
      </li>
      <li class="form__item">
        <v-textfield-public
          :label="usersLastName"
          :name="`person[`+[i]+`][last_name]`"
          v-validate="`required|alpha_spaces_dash`"
        ></v-textfield-public>
      </li>
      <li class="form__item">
        <v-textfield-public
          :name="`person[`+[i]+`][address][post_code]`"
          :ref="`person_postcode_` + i"
          :label="locales && locales.users && locales.users.post_code"
          @blur="checkPcHn($event, i)"
          class="js-postcode"
        ></v-textfield-public>
      </li>
      <li class="form__item">
        <v-textfield-public
          :name="`person[`+[i]+`][address][house_number]`"
          :ref="`person_housenumber_` + i"
          :label="locales && locales.users && locales.users.house_number"
          class="js-house-number"
          @blur="checkPostcodeAddress($event, i)"
        ></v-textfield-public>
      </li>
      <li class="form__item">
        <v-textfield-public
          :name="`person[`+[i]+`][address][street]`"
          :ref="`person_street_` + i"
          :label="locales && locales.users && locales.users.street"
        ></v-textfield-public>
      </li>
      <li class="form__item">
        <v-textfield-public
          :is-update-model="true"
          :name="`person[`+[i]+`][address][city]`"
          :ref="`person_city_` + i"
          :label="locales && locales.users && locales.users.city"
        ></v-textfield-public>
      </li>
      <li class="form__item">
        <v-datepicker-public
          :label="usersDateOfBirth"
          :name="`person[`+[i]+`][birthdate]`"
          v-validate="`required`"
        ></v-datepicker-public>
      </li>
      <li class="form__item">
        <v-textfield-public
          :label="usersPhoneNumber"
          :name="`person[`+[i]+`][phone_number]`"
          class="js-unique-phone"
          @blur="checkPhone"
          v-validate="`required|phone_number`"
        ></v-textfield-public>
      </li>
      <li class="form__item" v-if="!!is_phone_number_unique">
        <label class="form__label"></label>
        <b style="color: red;">{{incomePhoneNumberAlreadyExists}}</b>
        <input type="hidden" name="phone_number_unique" v-validate="`required`">
      </li>
      <li class="form__item">
        <v-textfield-public
          :label="usersEmail"
          :name="`person[`+[i]+`][email]`"
          type="email"
          class="js-unique-mail"
          v-validate="`required|email`"
          @blur="checkMail"
        ></v-textfield-public>
      </li>
        <label class="form__label"></label>
        <b style="color: red;">{{incomeIsUserAlreadyExists}}</b>
        <input type="hidden" name="user_already_exists" v-validate="`required`">
      </li>
      <li class="form__item" v-if="is_user_already_exists==2">
        <label class="form__label"></label>
        <b style="color: red;">{{incomeIsUserBanned}}</b>
        <input type="hidden" name="user_already_exists" v-validate="`required`">
      </li>
    </ul>
    <div class="form__heading">
      <h2
        v-if="familyTypeState == 'living_together'"
        class="form__title"
      >{{partner}} {{incomeTitle}}</h2>
      <h2 v-else class="form__title">{{subscriptions}} {{i+1}} {{incomeTitle}}</h2>
    </div>
    <ul class="form__list">
      <li class="form__item">
        <v-checkboxes-public
          :label="usersIAm"
          :name="`person[`+[i]+`][type_of_income][]`"
          :options="usersTypeOfIncomeOptions"
          @input="triggerIncomeAdditionalForms"
          v-validate="`required|make_choice`"
        ></v-checkboxes-public>
      </li>
      <!-- working or business -->
      <template v-if="income_form_work_business">
        <li class="form__item" v-if="income_form_work">
          <v-radios-public
            :label="usersContractType"
            :name="`person[`+[i]+`][working_contract_type_id]`"
            :options="usersContractTypeOptions"
            @input="triggerContractDuration"
            v-validate="`required|make_choice`"
          ></v-radios-public>
        </li>
        <template v-if="showDuration && income_form_work">
            <li class="form__item">
              <v-textfield-public
                :label="usersContractDuration"
                :name="`person[`+[i]+`][working_contract_duration]`"
                v-validate="`required|numeric`"
              ></v-textfield-public>
            </li>
            <li class="form__item">
              <v-datepicker-public
                :label="usersContractEndDate"
                :name="`person[`+[i]+`][working_contract_end_date]`"
                v-validate="`required`"
              ></v-datepicker-public>
            </li>
          </template>
        <li class="form__item">
          <v-textfield-public
            :label="usersOccupation"
            :name="`person[`+[i]+`][occupation]`"
            v-validate="`required`"
          ></v-textfield-public>
        </li>
        <li class="form__item">
          <v-textfield-public
            :label="usersMonthlyIncome"
            :name="`person[`+[i]+`][income]`"
            v-validate="`required|numeric`"
          ></v-textfield-public>
          <div class="form__bottom-row">{{usersMonthlyIncomeNote}}</div>
        </li>
        <li class="form__item">
          <v-radios-public
            :label="usersDoYouHaveGuarantorGeneral"
            :name="`person[`+[i]+`][guarantor]`"
            :options="usersDoYouHaveGuarantorOptions"
            value="0"
            @input="triggerGuarantorForm"
            v-validate="`required|make_choice`"
          ></v-radios-public>
        </li>
        <li v-if="guarantor_form_state == 1" class="form__item">
          <v-textfield-public
            :label="usersGuarantorIncome"
            :name="`person[`+[i]+`][guarantor_income]`"
            v-validate="`required|numeric`"
          ></v-textfield-public>
        </li>
      </template>
      <!-- studying -->
      <template v-if="income_form_studying">
        <template v-if="!income_form_work_business">
          <li class="form__item">
            <v-radios-public
              :label="usersDoYouHaveGuarantor"
              :name="`person[`+[i]+`][guarantor]`"
              :options="usersDoYouHaveGuarantorOptions"
              value="0"
              @input="triggerGuarantorForm"
              v-validate="`required|make_choice`"
            ></v-radios-public>
          </li>
          <li v-if="guarantor_form_state == 1" class="form__item">
            <v-textfield-public
              :label="usersGuarantorIncome"
              :name="`person[`+[i]+`][guarantor_income]`"
              v-validate="`required|numeric`"
            ></v-textfield-public>
          </li>
        </template>
        <li class="form__item">
          <v-textfield-public
            :label="usersStudy"
            :name="`person[`+[i]+`][study]`"
            v-validate="`required`"
          ></v-textfield-public>
        </li>
      </template>
      <li v-if="income_form_any" class="form__item form__item--align-start">
        <label class="form__label">{{usersExtraInformationIncome}}</label>
        <textarea class="form__textarea" :name="`person[`+[i]+`][income_note]`"></textarea>
      </li>
    </ul>
    <div class="form__heading">
      <h2
        class="form__title"
        v-if="familyTypeState == 'living_together'"
      >{{partner}} {{locales && locales.users && locales.users.landlord_details.toLowerCase()}}</h2>
      <h2
        class="form__title"
        v-else
      >{{subscriptions}} {{i+1}} {{locales && locales.users && locales.users.landlord_details.toLowerCase()}}</h2>
    </div>
    <ul class="form__list">
      <li class="form__item">
        <v-radios-public
          :label="locales && locales.users && locales.users.who_is_your_landlord"
          :name="`person[`+[i]+`][landlord_status]`"
          :options="usersLandlordOptions"
          @input="triggerLandlordType"
        ></v-radios-public>
      </li>
      <li v-if="landlord_type_state == 'renting_property'" class="form__item">
        <ul class="form__list">
          <li class="form__item">
            <v-textfield-public
              :label="locales && locales.users && locales.users.landlord_name"
              :name="`person[`+[i]+`][landlord_name]`"
            ></v-textfield-public>
          </li>
          <li class="form__item">
            <v-textfield-public
              :label="locales && locales.users && locales.users.landlord_email"
              :name="`person[`+[i]+`][landlord_email]`"
              v-validate="`email`"
            ></v-textfield-public>
          </li>
          <li class="form__item">
            <v-textfield-public
              :label="locales && locales.users && locales.users.landlord_phone_number"
              :name="`person[`+[i]+`][landlord_phone_number]`"
              v-validate="`phone_number`"
            ></v-textfield-public>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  inject: ["$validator"],
  data() {
    return {
      income_form_any: false,
      income_form_studying: false,
      income_form_work_business: false,
      income_form_work: false,
      income_form_all_states: this.incomeFormAllStates,
      income_form_state: -1,
      guarantor_form_state: -1,
      is_user_already_exists: 0,
      landlord_type_state: this.landlordTypeState,
      showDuration: false,
      is_phone_number_unique: 0,
    };
  },
  computed: {
    ...mapGetters(["locales"])
  },
  props: {
    i: {
      default: 0,
      type: Number
    },
    partner: {
      default: "",
      type: String
    },
    familyTypeState: {
      default: "",
      type: String
    },
    subscriptions: {
      default: "",
      type: String
    },
    usersFirstName: {
      default: "",
      type: String
    },
    usersTitleOptions: {
      default: () => {},
      type: Object
    },
    usersMiddleName: {
      default: "",
      type: String
    },
    usersLastName: {
      default: "",
      type: String
    },
    usersDateOfBirth: {
      default: "",
      type: String
    },
    usersPhoneNumber: {
      default: "",
      type: String
    },
    usersEmail: {
      default: "",
      type: String
    },
    usersCivilState: {
      default: "",
      type: String
    },
    usersCivilStateOptions: {
      default: () => {},
      type: Object
    },
    usersIAm: {
      default: "",
      type: String
    },
    usersTypeOfIncomeOptions: {
      default: () => {},
      type: Object
    },
    usersContractType: {
      default: "",
      type: String
    },
    usersContractTypeOptions: {
      default: () => {},
      type: [Object, Array]
    },
    usersContractTypeAttributes: {
      default: () => {},
      type: [Object, Array]
    },
    usersContractDuration: {
      default: "",
      type: String
    },
    usersContractEndDate: {
      default: "",
      type: String
    },
    usersOccupation: {
      default: "",
      type: String
    },
    usersMonthlyIncome: {
      default: "",
      type: String
    },
    usersMonthlyIncomeNote: {
      default: "",
      type: String
    },
    usersDoYouHaveGuarantor: {
      default: "",
      type: String
    },
    usersDoYouHaveGuarantorGeneral: {
      default: "",
      type: String
    },
    usersDoYouHaveGuarantorOptions: {
      default: () => {},
      type: Object
    },
    usersGuarantorIncome: {
      default: "",
      type: String
    },
    usersStudy: {
      default: "",
      type: String
    },
    usersExtraInformationIncome: {
      default: "",
      type: String
    },
    incomeFormAllStates: {
      default: () => [],
      type: Array
    },
    incomeTitle: {
      default: "",
      type: String
    },
    usersTypeOfIncomeSlugs: {
      default: () => {},
      type: Object
    },
    incomeIsUserAlreadyExists: {
      default: "",
      type: String
    },
    incomeIsUserBanned: {
      default: "",
      type: String
    },
    landlordTypeState: {
      default: "-1",
      type: String
    },
    usersLandlordOptions: {
      default: () => {},
      type: Object
    },
    incomePhoneNumberAlreadyExists: {
      default: "",
      type: String
    },
    defaultLanguage: {
      default: "",
      type: String,
    },
    languages: {
      default: () => {},
      type: Object,
    },
  },
  methods: {
    triggerIncomeAdditionalForms: function(value) {
      if (value) this.income_form_state = value;

      this.income_form_any = false;
      this.income_form_studying = false;
      this.income_form_work_business = false;
      this.income_form_work = false;

      for (var i = 0; i < this.income_form_state.length; i++) {
        var state = this.usersTypeOfIncomeSlugs[this.income_form_state[i]];

        if (this.income_form_all_states.indexOf(state) > -1) {
          this.income_form_any = true;
          if (state == "own_business" || state == "working") {
            this.income_form_work_business = true;
          }
          if (state == "working") {
            this.income_form_work = true;
          }
          if (state == "studying") {
            this.income_form_studying = true;
          }
        }
      }
    },
    triggerContractDuration: function(value) {
      this.showDuration = false;
      var option = this.usersContractTypeAttributes[value];
      if (option == "1") {
        this.showDuration = true;
      }
    },
    triggerGuarantorForm: function(value) {
      if (value) {
        if (value !== true) {
          this.guarantor_form_state = value;
        } else {
          this.guarantor_form_state = -1;
        }
      } else {
        this.guarantor_form_state = -1;
      }
    },
    triggerLandlordType: function(value) {
      this.landlord_type_state = value;
    },
    checkMail: function(event) {
      var email = event.target.value;
      if (email == "") return (this.is_user_already_exists = 0);
      var vm = this;
      $.ajax({
        url: `/api/users/check-mail`,
        method: "post",
        data: {
          email: email
        },
        success: function(result) {
          var elements = document.getElementsByClassName('js-unique-mail'),
              mails = [];

            Array.prototype.forEach.call(elements, function(el) {
                // Do stuff here
                let val = el.querySelector('input').value;
                if(el.querySelector('input') != event.target && val != ''){
                  mails.push(val);
                }
            });

          if (parseInt(result) === 1) {
            vm.is_user_already_exists = 1;
          } else {
            if (mails.length && mails.indexOf(email) != -1) {
              vm.is_user_already_exists = 1;
            } else {
              vm.is_user_already_exists = 0;
            }
          }
        },
        error: function() {}
      });
    },
    checkPhone: function(event) {
      var phone = event.target.value;
      if (phone == "") return (this.is_phone_number_unique = 0);
      var vm = this;
      var elements = document.getElementsByClassName('js-unique-phone');
      var phones = [];
      Array.prototype.forEach.call(elements, function(el) {
          // Do stuff here
          let val = el.querySelector('input').value;
          if(el.querySelector('input') != event.target && val != ''){
            phones.push(val);
          }
      });
      if(phones.length && phones.indexOf(phone) != -1){
        vm.is_phone_number_unique = 1;
      }else{
        vm.is_phone_number_unique = 0;
      }
    },
    checkPcHn(event, i) {
      this.validated = false;
      this.changed = true;
      var that = this;
      setTimeout(function () {
        var postcode = $("[name='person["+[i]+"][address][post_code]']")
          .first()
          .val();
        var house_number = $("[name='person["+[i]+"][address][house_number]']")
          .first()
          .val();
        if (postcode && postcode != "") {
          $.post(
            "/get-street-location",
            {
              postcode: postcode,
              house_number: house_number,
            },
            function (data) {
              if (data.error == "false") {
                $("[name='person["+[i]+"][address][city]']")
                  .first()
                  .val(data.location);
                $("[name='person["+[i]+"][address][street]']")
                  .first()
                  .val(data.street);
                var ref1= 'person_street_' + i;
                var ref2= 'person_city_' + i;
                that.$refs[ref1].model= data.street;
                that.$refs[ref2].model= data.location;
              }
            },
            "json"
          );
        }
      }, 100);
    },
    checkPostcodeAddress(event, i) {
      this.validated = false;
      this.changed = true;
      var that = this;
      setTimeout(function () {
        var street = $("[name='person["+[i]+"][address][street]']")
          .first()
          .val();
        var house_number = $("[name='person["+[i]+"][address][house_number]']")
          .first()
          .val();
        var location = $("[name='person["+[i]+"][address][city]']")
          .first()
          .val();
        if (street != "" && house_number != "") {
          $.post(
            `/get-postcode-by-address`,
            {
              street: street,
              house_number: house_number,
              location: location,
            },
            function (data) {
              if (data.error == "false") {
                $("[name='person["+[i]+"][address][post_code]']")
                  .first()
                  .val(data.postcode);
                var ref= 'person_postcode_' + i;
                that.$refs[ref].model= data.postcode;
              }
            },
            "json"
          );
        }
      }, 100);
    },
  },
  beforeMount() {
    this.triggerIncomeAdditionalForms();
  }
};
</script>